<template>
	<div>
		<!-- Popup for users without 2FA enabled -->
		<AppPopup
			ref="popup-no-2fa"
			:title="getString('two_factor_authentication')"
			:body-text="getString('two_factor_not_enabled_message')"
			:buttons="[
				{ text: getString('close'), negative: true },
				{ text: getString('go_to_settings'), callback: goToSettings }
			]"
		/>

		<!-- Popup for users with 2FA enabled -->
		<AppPopup
			ref="popup-otp-input"
			:title="getString('enter_otp_code')"
			:buttons="[
				{ text: getString('close'), negative: true },
				{ text: getString('confirm'), callback: submitOtp }
			]"
		>
			<div class="otp-input-container">
				<label for="otp-code">{{ getString('otp_code_label') }}</label>
				<input
					id="otp-code"
					v-model="otpCode"
					type="text"
					class="form-control"
					:placeholder="getString('otp_placeholder')"
					maxlength="6"
					@keypress="onlyNumbers"
					@keyup.enter="submitOtp"
				/>
				<div v-if="errorMessage" class="error-message">
					{{ errorMessage }}
				</div>
			</div>
		</AppPopup>
	</div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/console-new/stores/user.store';
import { useLanguageStore } from '@/shared/stores/language.store';
import AppPopup from '@/shared/components/AppPopup.vue';

export default {
	name: 'OtpPopup',
	components: {
		AppPopup
	},
	emits: ['new-otp'],
	data() {
		return {
			otpCode: '',
			errorMessage: ''
		};
	},
	computed: {
		...mapStores(useUserStore, useLanguageStore)
	},
	methods: {
		getString(key) {
			return this.languageStore.getString(key);
		},
		askOtp() {
			// Reset state
			this.otpCode = '';
			this.errorMessage = '';

			// Check if user has 2FA enabled
			if (!this.userStore.user.tfa_secret) {
				// Show popup for users without 2FA
				this.$refs['popup-no-2fa'].toggleStatus(true);
			} else {
				// Show popup for OTP input
				this.$refs['popup-otp-input'].toggleStatus(true);
			}
		},
		goToSettings() {
			// Close popup and redirect to settings
			this.$refs['popup-no-2fa'].toggleStatus(false);
			window.location.href = URL_HTML + '/user/settings';
		},
		submitOtp() {
			// Validate OTP format (6 digits)
			if (!/^\d{6}$/.test(this.otpCode)) {
				this.errorMessage = this.getString('invalid_otp_format');
				return;
			}

			// Close popup and emit the OTP
			this.$refs['popup-otp-input'].toggleStatus(false);
			this.$emit('new-otp', this.otpCode);
		},
		onlyNumbers(event) {
			// Allow only numeric input
			const char = String.fromCharCode(event.keyCode);
			if (!/[0-9]/.test(char)) {
				event.preventDefault();
			}
		}
	}
};
</script>

<style scoped>
.otp-input-container {
	padding: 20px 0;
}

.otp-input-container label {
	display: block;
	margin-bottom: 10px;
	font-weight: 600;
	color: var(--color-txt);
}

.otp-input-container input {
	width: 100%;
	padding: 12px;
	font-size: 18px;
	text-align: center;
	letter-spacing: 8px;
	border: 1px solid var(--color-border);
	border-radius: 13px;
	transition: border-color 0.3s;
	background-color: var(--color-bg-primary-2);
	color: var(--color-txt);
}

.otp-input-container input:focus {
	border-color: var(--color-primary);
	outline: none;
}

.error-message {
	margin-top: 10px;
	color: var(--color-danger);
	font-size: 14px;
	text-align: center;
}
</style>